import React from 'react'
import { INFTSellModalNonYTSFeeProps } from '../models/INFTSellModal'
import { FeeWrapper } from '../styles/NFTSellModalFeeStyled'
import { useGetYetiswapMarketCreatorRate } from '../../../../../hooks/useNFTMarketPlace'

export default function NonYTSNFTFee(props: INFTSellModalNonYTSFeeProps) {
  const { commissionRate, price, tokenName, collectionAddress } = props
  const tokenRoyalities = useGetYetiswapMarketCreatorRate(collectionAddress)
  const parsedPrice = parseFloat(price)
  const sellPrice: number = !isNaN(parsedPrice) ? parsedPrice : 0

  function calculateReceive() {
    const serviceFee = (sellPrice * commissionRate) / 100
    let royalities = 0
    if (tokenRoyalities) {
      royalities = (sellPrice * tokenRoyalities) / 100
    }

    return sellPrice - serviceFee - royalities
  }
  return (
    <FeeWrapper>
      <div>Service Fee: {commissionRate}%</div>
      {tokenRoyalities ? <div>Royalties: {tokenRoyalities}%</div> : ''}
      <div>
        You will receive {calculateReceive()} {tokenName}
      </div>
    </FeeWrapper>
  )
}
